<template>
    <div class="container flex flex-direction">
        <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
        <div class="header-container flex align-center justify-between">
            <div class="flex align-center">
                <div class="btn-container" @click="$router.go(-1)">
                    <div class="btn"><i class="iconfont icon-fanhui margin-right-xs"></i>返回</div>
                </div>

            </div>
            <div class="page-title">双暖孝亲亲情守护平台</div>
            <div class="flex align-center">
                <div class="btn-container max right margin-left-sm">
                    <div class="btn">{{ cur_time | date_time }}</div>
                </div>

            </div>
        </div>
        <div class="content-container flex flex-direction flex-sub">
            <div class="info-container total-container flex align-center">

                <div class="total-item flex align-center" v-if="total.service_people_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_1.png">
                    <div class="flex align-center">
                        <div class="title">服务总人数</div>
                        <div class="flex">
                            <dv-digital-flop
                                :config="{ style: style, number: [total.service_people_num], content: '{nt}' }"
                                class="number" :style="total.service_people_num_style" />
                            <div class="label self-end">人</div>
                        </div>
                    </div>
                </div>
                <div class="total-item flex align-center" v-if="total.service_num_style">
                    <img class="image" src="../../../assets/img/data/icon_service_info_total_3.png">
                    <div class="flex align-center">
                        <div class="title">服务总次数</div>
                        <div class="flex">
                            <dv-digital-flop :config="{ style: style, number: [total.service_num], content: '{nt}' }"
                                class="number" :style="total.service_num_style" />
                            <div class="label self-end">次</div>
                        </div>
                    </div>
                </div>
                <div class="total-item flex align-center justify-center">
                    <div class="title">天气信息</div>
                    <img class="image margin-lr-sm" :src="total.weather.image">
                    <div class="title">{{ total.weather.weather }}</div>
                    <div class="weather">{{ total.weather.temperature }}</div>
                    <div class="title">℃</div>
                </div>
            </div>


            <div class="flex margin-top-sm flex-sub">
                <div class="info-container min flex flex-direction">
                    <div class="classify-title left">服务内容</div>
                    <!--                    <el-dropdown placement="bottom" trigger="click" @command="handleCommand">-->
                    <!--                        <div class="select">-->
                    <!--                            {{ date_name || '近一年' }}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                    <!--                        </div>-->
                    <!--                        <el-dropdown-menu class="date-select" slot="dropdown">-->
                    <!--                            <el-dropdown-item v-for="(item,index) in dates" :key="index" :command="item">{{ item.label-->
                    <!--                                }}-->
                    <!--                            </el-dropdown-item>-->
                    <!--                        </el-dropdown-menu>-->
                    <!--                    </el-dropdown>-->
                    <div class="service-container flex flex-direction">
                        <div class="flex flex-wrap justify-between">
                            <div class="remind-item flex flex-direction">
                                <div class="flex align-center self-center">
                                    <div class="title">生日祝福</div>
                                </div>
                                <div class="number-container flex align-center justify-between">
                                    <img class="image" src="../../../assets/img/data/icon_service_info_flove_1.png">
                                    <div class="flex align-center">
                                        <div class="number">{{ total.shengri_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="remind-item flex flex-direction">
                                <div class="flex align-center self-center">
                                    <div class="title">天气提醒</div>
                                </div>
                                <div class="number-container flex align-center justify-between">
                                    <img class="image" src="../../../assets/img/data/icon_service_info_flove_2.png">
                                    <div class="flex align-center">
                                        <div class="number">{{ total.tianqi_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="remind-item flex flex-direction">
                                <div class="flex align-center self-center">
                                    <div class="title">节日祝福</div>
                                </div>
                                <div class="number-container flex align-center justify-between">
                                    <img class="image" src="../../../assets/img/data/icon_service_info_flove_3.png">
                                    <div class="flex align-center">
                                        <div class="number">{{ total.jieri_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>
                            <div class="remind-item flex flex-direction">
                                <div class="flex align-center self-center">
                                    <div class="title">节气提醒</div>
                                </div>
                                <div class="number-container flex align-center justify-between">
                                    <img class="image" src="../../../assets/img/data/icon_service_info_flove_4.png">
                                    <div class="flex align-center">
                                        <div class="number">{{ total.jieqi_num }}</div>
                                        <div class="label">次</div>
                                    </div>
                                </div>
                            </div>

                            <div class="festival-item flex flex-direction align-center">
                                <div class="title">近期节日</div>
                                <img class="image" :src="total.jieri.image">
                                <div class="flex align-center">
                                    <div class="name">{{ total.jieri.name }}</div>
                                    <div class="date">{{ total.jieri.time }}</div>
                                </div>
                            </div>
                            <div class="festival-item flex flex-direction align-center">
                                <div class="title">近期节气</div>
                                <img class="image" :src="total.jieqi.image">
                                <div class="flex align-center">
                                    <div class="name">{{ total.jieqi.name }}</div>
                                    <div class="date">{{ total.jieqi.time }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-direction flex-sub margin-lr-sm">
                    <div class="image-container flex-sub">
                        <el-carousel class="carousel" :interval="4000" type="card" height="415px"
                            :indicator-position="'none'" arrow="always" ref="carousels">
                            <el-carousel-item class="carousel-item" v-for="(item, index) in total.banner" :key="index">
                                <el-image class="image" :fit="'cover'" :src="item"
                                    :preview-src-list="total.banner"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="info-container birthday-container flex flex-direction flex-sub">
                        <div class="classify-title self-center">近期服务对象生日</div>
                        <!--                        <div class="operate-container flex align-center justify-between">-->
                        <!--                            <div class="operate" @click="yibanRefresh"><i class="iconfont icon-shuaxin"></i> 刷新</div>-->
                        <!--                            <div class="flex align-center">-->
                        <!--                                <div class="operate" @click="yibanLast">上一页</div>-->
                        <!--                                <div class="page">{{ yj_yiban_page }}/{{ yj_yiban_total_page }}</div>-->
                        <!--                                <div class="operate" @click="yibanNext">下一页</div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div class="birthday-list flex flex-wrap justify-between margin-top-xs">
                            <div class="birthday-item flex align-center" v-for="(item, index) in total.birthday"
                                :key="index">
                                <div class="tip-container flex flex-direction justify-center align-center">
                                    <div class="tip">{{ item.name }}</div>
                                </div>
                                <div class="flex flex-direction">
                                    <div class="flex align-center">
                                        <div class="name"><i class="icon el-icon-date"></i>{{ item.shengri }}</div>
                                    </div>
                                    <div class="address margin-top-xs"><i class="icon el-icon-phone"></i>{{ item.phone
                                        || '--' }} </div>
                                </div>
                            </div>
                            <el-empty class="w-all" v-if="!total.birthday.length"></el-empty>
                        </div>

                    </div>
                </div>
                <div class="info-container min flex flex-direction align-center">
                    <div class="classify-title">服务对象</div>
                    <div class="flex margin-top-sm">
                        <div class="sex-container">
                            <div class="echart-title">性 别</div>
                            <div id="sex_echarts" class="echarts"></div>
                        </div>
                        <div class="sex-container margin-left-xs">
                            <div class="echart-title">属 性</div>
                            <div id="shuxing_echarts" class="echarts"></div>
                        </div>
                    </div>
                    <div class="year-container flex flex-direction margin-top-sm">
                        <div class="echart-title">年 龄</div>
                        <div id="year_echarts" class="echarts"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { zhDate } from "@/utils/utils";
import { dataScreenLoveTotal } from "@/api/tongji";
import * as echarts from 'echarts';
import { upFeil } from "@/config";

export default {
    name: "service_flove",
    components: {},
    data() {
        return {
            mapImg: '',
            dates: [{
                value: 1, label: '近一年'
            }],
            date_name: '',
            date_id: '',

            cur_time: new Date().getTime(),
            style: {
                fontSize: 36,
                fill: '#ffd200',
                fontFamily: 'PingFang SC',
                fontWeight: 'bold',
                fontStyle: 'italic'
            },

            loading: false,
            total: {
                service_people_num: 0,
                service_num: 0,
                tianqi_num: 0,
                shengri_num: 0,
                jieqi_num: 0,
                jieri_num: 0,
                weather: {},
                jieqi: {},
                jieri: {},
                birthday: [],
            },

            year_option: {
                animationDuration: 2000,
                animationEasing: 'cubicOut',
                grid: {
                    bottom: 30,
                    right: 30,
                    top: 30
                },
                xAxis: {
                    data: [],
                    axisTick: {
                        show: false //去除刻度线
                    },
                    axisLabel: {
                        rotate: 0,
                        color: '#fff',
                        fontSize: 10
                    },
                    axisLine: {
                        show: true, //去除轴线
                        lineStyle: {
                            color: '#fff',
                            width: 2
                        }
                    },

                },
                yAxis: {
                    type: 'value',
                    minInterval: 1,
                    axisLabel: {
                        color: '#fff',
                        fontSize: 10
                    },
                    axisTick: {
                        show: false //去除刻度线
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#fff1',
                        }
                    },
                    axisLine: {
                        show: false, //去除轴线
                        lineStyle: {
                            color: '#fff',
                            width: 2
                        }
                    },
                },
                series: {
                    data: [],
                    type: 'bar',
                    barWidth: 50,
                    label: {
                        show: false,
                        position: 'top',
                        valueAnimation: true,
                        color: '#fff'
                    },
                    itemStyle: {
                        borderRadius: [6, 6, 0, 0], //（顺时针左上，右上，右下，左下）
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 1, color: '#009cff' // 0% 处的颜色
                            }, {
                                offset: 0, color: '#00eaff' // 100% 处的颜色
                            }],
                            global: false // 缺省为 false
                        }
                    }

                }
            },
            sex_option: {
                animationDuration: 3000,
                animationEasing: 'cubicOut',
                legend: {
                    icon: 'circle',
                    itemWidth: 5,
                    itemHeight: 5,
                    itemGap: 10,
                    left: 'auto',
                    right: 'auto',
                    bottom: '10px',
                    textStyle: {
                        fontSize: 10,
                        color: '#fff'
                    },
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)'
                },
                color: ['#15b3e7', '#fd8c4b'],
                series:
                {
                    type: 'pie',
                    radius: [0, 40],
                    label: {
                        color: "#fff",
                        formatter: [
                            '{b}{a|{c}}人'
                        ].join('\n'),
                        rich: {
                            a(e) {
                                return {
                                    color: e
                                }
                            }
                        }
                    },
                    labelLine: {
                        length: 5,
                        length2: 5,
                    },
                    itemStyle: {
                        // borderRadius: 2
                    },
                    data: []
                }
            },
            shuxing_option: {
                animationDuration: 3000,
                animationEasing: 'cubicOut',
                legend: {
                    icon: 'circle',
                    itemWidth: 5,
                    itemHeight: 5,
                    itemGap: 10,
                    left: 'auto',
                    right: 'auto',
                    bottom: '10px',
                    textStyle: {
                        fontSize: 10,
                        color: '#fff'
                    },
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)'
                },
                color: ['#28ddca', '#55a1f4', '#ac80fa'],
                series: {
                    type: 'pie',
                    radius: [0, 40],
                    label: {
                        color: "#fff",
                        formatter: [
                            '{b}{a|{c}}人'
                        ].join('\n'),
                        rich: {
                            a(e) {
                                return {
                                    color: e
                                }
                            }
                        }
                    },
                    labelLine: {
                        length: 5,
                        length2: 5,
                    },
                    itemStyle: {
                        // borderRadius: 2
                    },
                    data: []
                }

            },
            project_id: '',
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.project_id = this.$route.query.xiangmu_id
        this.getCurrentTime()
    },
    mounted() {
        this.onload()
    },
    methods: {
        onload() {
            this.loading = true
            this.init()
            this.setTimeoutGetData()
        },

        setTimeoutGetData() {
            setInterval(() => {
                this.init()
            }, 1000 * 60)
        },
        //  获取数据
        async init() {
            let _data = await dataScreenLoveTotal(this.project_id)
            _data.data.service_num_style = this.getStyle(_data.data.service_num)
            _data.data.service_people_num_style = this.getStyle(_data.data.service_people_num)
            let year_echarts = echarts.init(document.getElementById('year_echarts'))
            this.year_option.xAxis.data = _data.data.age.map(item => {
                return item.name
            })
            this.year_option.series.data = _data.data.age.map(item => {
                return item.value
            })
            year_echarts.setOption(this.year_option)
            let sex_echarts = echarts.init(document.getElementById('sex_echarts'))
            this.sex_option.series.data = _data.data.sex
            sex_echarts.setOption(this.sex_option)

            let shuxing_echarts = echarts.init(document.getElementById('shuxing_echarts'))
            this.shuxing_option.series.data = _data.data.attribute
            shuxing_echarts.setOption(this.shuxing_option)
            _data.data.jieqi.image = upFeil + _data.data.jieqi.image
            _data.data.jieri.image = upFeil + _data.data.jieri.image
            this.total = _data.data
            this.loading = false
        },
        getCurrentTime() {
            setInterval(() => {
                this.cur_time = new Date().getTime()
            }, 1000)
        },
        getStyle(num, size = 36) {
            return `width:${num.toString().length * size}px`
        }
    },
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            switch (Number(val)) {
                case 1:
                    return '主动求救'
                case 2:
                    return '心率异常'
                case 3:
                    return '体温异常'
                case 4:
                    return '血糖异常'
                case 5:
                    return '血氧异常'
                case 6:
                    return '血压异常'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ {
    .el-carousel__arrow {
        background-color: #ffffff;
        opacity: 0.7;
        color: #333333;
        display: block;
    }

    .el-carousel__arrow--left {
        left: 176px;
    }

    .el-carousel__arrow--right {
        right: 176px;
    }
}

.container {
    height: 100vh;
    min-width: 1920px;
    min-height: 1080px;
    overflow: hidden;
    background: url(../../../assets/img/data/bg_flove.jpg) no-repeat top;
    background-size: 100% 100%;

    .loading {
        color: #ffffff;
        position: fixed;
        background: #33333333;
        z-index: 10;
    }

    .header-container {
        height: 102px;
        position: relative;
        padding: 0 36px;

        .page-title {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 600;
            color: #ffffff;
        }

        .btn-container {
            transform: skew(25deg);
            width: 152px;
            height: 48px;
            min-width: 137px;
            line-height: 48px;
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            background-color: #173979;
            text-align: center;
            font-size: 18px;
            color: #19caff;
            font-weight: 500;
            cursor: pointer;


            &.right {
                transform: skew(-25deg);

                .btn {
                    transform: skew(25deg);
                }
            }

            .btn {
                transform: skew(-25deg);
            }

            &.max {
                width: 282px;
            }

            &.mid {
                width: 182px;
            }
        }


    }

    .content-container {
        //box-shadow: inset -10px 20px 18px -20px #0096ff;
        //background-color: #173979;
        padding: 26px;

        .image-container {
            margin: 12px;
            width: 815px;
            position: relative;
            overflow: hidden;

            .carousel {
                width: 1050px;
                height: 415px;
                transform: translateX(-50%);
                left: 50%;

                .carousel-item {
                    width: calc(600px * 0.83);
                    height: calc(415px * 0.83);
                    overflow: unset;
                }

                .image {
                    width: 100%;
                    height: 100%;
                    border: solid 2px #ffffff;
                    object-fit: cover;
                }
            }

        }

        .info-container {
            box-shadow: inset 0px 0px 8px 3px #0096ff;
            //background-image: linear-gradient(0deg,
            //    #0c5da399 0%,
            //    #00226299 100%);
            background-blend-mode: normal,
                normal;
            position: relative;
            overflow: hidden;

            &.min {
                width: 495px;
            }

            .more {
                color: #0096ff;
                font-size: 12px;
                position: absolute;
                right: 20px;
                top: 20px;
                cursor: pointer;
            }

            .classify-title {
                background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
                background-size: 100% 100%;
                width: 242px;
                height: 41px;
                line-height: 41px;
                text-align: center;
                font-size: 18px;
                font-weight: 600;
                color: #19caff;

                &.left {
                    margin-left: -20px;
                }
            }

            .select {
                width: 102px;
                height: 28px;
                line-height: 28px;
                box-shadow: inset 0px 0px 8px 3px #0096ff;
                background-color: #173979;
                text-align: center;
                font-size: 14px;
                color: #19caff;
                cursor: pointer;
                position: absolute;
                right: 20px;
                top: -30px;
            }

            &.birthday-container {
                padding: 0 37px;
                margin: 0 12px;
                position: relative;

                .operate-container {
                    position: absolute;
                    top: 22px;
                    left: 37px;
                    right: 37px;

                    .operate {
                        width: 71px;
                        height: 28px;
                        line-height: 28px;
                        text-align: center;
                        box-shadow: inset 0px 0px 8px 3px #0096ff;
                        font-size: 14px;
                        color: #19caff;
                        cursor: pointer;
                    }

                    .page {
                        width: 71px;
                        font-size: 14px;
                        text-align: center;
                        color: #19caff;
                    }
                }

                .birthday-list {
                    height: 280px;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        background: transparent;
                        width: 2px;
                        height: 5px;
                    }

                    &::-webkit-scrollbar-thumb {
                        background: #18c6fb;
                        width: 2px;
                    }
                }


                .birthday-item {
                    width: calc(100% / 2 - 30px);
                    height: 79px;
                    background-color: #173979;
                    border-radius: 5px;
                    margin-top: 10px;
                    margin-left: 13px;
                    position: relative;
                    padding-left: 74px;

                    .tip-container {
                        position: absolute;
                        width: 73px;
                        height: 63px;
                        background-color: #19caff;
                        border-radius: 5px;
                        top: 50%;
                        left: -13px;
                        transform: translateY(-50%);

                        .tip {
                            font-size: 16px;
                            color: #ffffff;
                            font-weight: 600;
                        }
                    }

                    .name {
                        font-size: 18px;
                        font-weight: 600;
                        color: #ffffff;

                    }

                    .icon {
                        color: #b1c5eb;
                        margin-right: 3px;
                    }

                    .phone,
                    .address {
                        font-size: 14px;
                        color: #b1c5eb;
                    }

                    .time {
                        position: absolute;
                        right: 10px;
                        top: 0px;
                        font-size: 12px;
                        color: #19caff;
                    }
                }
            }

            .echart-title {
                font-size: 18px;
                line-height: 16px;
                color: #ffffff;
                padding-left: 32px;
                position: relative;

                &:after {
                    position: absolute;
                    content: '';
                    width: 6px;
                    height: 18px;
                    background-color: #19caff;
                    border-radius: 3px;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                }

                &:before {
                    position: absolute;
                    content: '';
                    height: 18px;
                    background-image: linear-gradient(90deg,
                            rgba(25, 202, 255, 0.4) 0%,
                            #00226266 100%);
                    left: 90px;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }

            .year-container {
                background-color: #00226266;
                border-radius: 10px;
                border: solid 1px #19caff55;
                padding: 28px 16px;
                width: 450px;
                height: 318px;

                .echarts {
                    width: 450px;
                    height: 240px;
                    margin-top: 20px;
                }
            }

            .sex-container {
                background-color: #00226266;
                border-radius: 10px;
                border: solid 1px #19caff55;
                padding: 28px 16px;
                width: 219px;
                height: 352px;

                .echarts {
                    width: 200px;
                    height: 300px;
                }
            }



            .service-container {
                padding: 0 23px;


                .festival-item {
                    width: 219px;
                    height: 343px;
                    background-color: #00226266;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 28px 16px;
                    margin-top: 15px;

                    .title {
                        font-size: 18px;
                        color: #ffffff;
                    }

                    .image {
                        width: 186px;
                        height: 198px;
                        border-radius: 10px;
                        margin-top: 28px;
                        margin-bottom: 20px;
                        object-fit: scale-down;
                    }

                    .name {
                        font-size: 24px;
                        font-weight: 600;
                        color: #ff6464;
                    }

                    .date {
                        font-size: 18px;
                        color: #ffffff;
                        margin-left: 20px;
                    }
                }


                .remind-item {
                    width: 219px;
                    height: 160px;
                    background-color: #00226266;
                    border-radius: 10px;
                    border: solid 1px #19caff55;
                    padding: 16px 10px;
                    margin-top: 15px;


                    .title {
                        font-size: 18px;
                        color: #ffffff;
                    }

                    .number-container {
                        background: linear-gradient(90deg, #ffffff01 0%, #ffffff01 10%, #062b66 50%, #ffffff01 90%, #ffffff01 100%);
                        background-blend-mode: normal, normal;
                        position: relative;
                        width: 100%;
                        height: 78px;
                        margin-top: 18px;
                        padding: 0 12px;

                        &::after {
                            width: 100%;
                            height: 1px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            top: 0;
                            left: 0;
                            right: 0;
                        }

                        &::before {
                            width: 100%;
                            height: 1.5px;
                            background: linear-gradient(70deg, #19caff33 0%, #1b85bf 30%, #19caff 50%, #1b85bf 80%, #19caff33 100%);
                            position: absolute;
                            content: '';
                            bottom: 0;
                            left: 0;
                            right: 0;
                        }


                        .label {
                            font-size: 12px;
                            color: #fefefe;
                            margin-left: 6px;
                        }

                        .image {
                            height: 25px;
                            margin-right: 20px;
                        }

                        .number {
                            font-size: 30px;
                            font-weight: 600;
                            color: #ffd200;
                        }
                    }
                }
            }

            &.total-container {
                width: 100%;
                height: 128px;

                .total-item+.total-item {
                    border-left: 1px solid #10a6f555;
                }

                .total-item {
                    flex: 1;

                    .image {
                        width: 64px;
                        height: 64px;
                        margin-left: 80px;
                        margin-right: 20px;
                    }

                    .label {
                        font-size: 14px;
                        color: #ffffff;
                        margin-top: 3px;
                        margin-left: 5px;
                    }

                    .weather {
                        font-size: 36px;
                        line-height: 36px;
                        font-weight: 600;
                        color: #ffd200;
                    }

                    .number {
                        height: 36px;
                    }

                    .title {
                        font-size: 16px;
                        color: #ffffff;
                        margin-top: 12px;
                    }
                }
            }
        }


    }
}
</style>
